module.exports = __webpack_public_path__ + "static/media/2017-MAT Survey Results.c832801a.pdf";